export default function PainPoints() {
  const painPoints = [
    {
      icon: 'ri-user-search-line',
      number: '01',
      title: 'Точечно нанимаете фрилансеров',
      description: 'И ждёте чуда, которое так и не происходит? Каждый раз новый подрядчик — и снова с нуля.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      number: '02',
      title: 'Сливаете бюджеты',
      description: 'В Яндекс и Google без видимого результата? Деньги уходят, а заявок больше не становится.'
    },
    {
      icon: 'ri-question-line',
      number: '03',
      title: 'Есть ощущение',
      description: '«Я что-то делаю не так», но нет понимания, как исправить? Хаос вместо системы.'
    }
  ];

  return (
    <section className="py-28 bg-[#1A2B4C] relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C5A880] to-transparent opacity-60"></div>
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#C5A880] to-transparent opacity-60"></div>
      <div className="absolute top-20 right-10 w-64 h-64 rounded-full border border-[#C5A880]/10 pointer-events-none"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 rounded-full border border-[#C5A880]/10 pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-[#C5A880]/5 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-10 h-px bg-[#C5A880]"></div>
            <span className="text-[#C5A880] text-sm font-semibold tracking-[0.2em] uppercase font-['Montserrat']">Диагностика</span>
            <div className="w-10 h-px bg-[#C5A880]"></div>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-['Playfair_Display'] leading-tight">
            Знакомая ситуация?
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto font-['Montserrat'] leading-relaxed">
            Большинство предпринимателей сталкиваются с одними и теми же барьерами на пути к росту
          </p>
        </div>

        {/* Pain Points Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {painPoints.map((point, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 hover:border-[#C5A880]/40 transition-all duration-400 cursor-default"
            >
              {/* Gold top accent line */}
              <div className="absolute top-0 left-8 right-8 h-px bg-gradient-to-r from-transparent via-[#C5A880]/60 to-transparent group-hover:via-[#C5A880] transition-all duration-300"></div>

              {/* Number */}
              <div className="text-[#C5A880]/20 text-7xl font-bold font-['Playfair_Display'] leading-none mb-4 select-none group-hover:text-[#C5A880]/30 transition-colors duration-300">
                {point.number}
              </div>

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center bg-[#C5A880]/10 border border-[#C5A880]/30 rounded-xl mb-6 group-hover:bg-[#C5A880]/20 transition-all duration-300">
                <i className={`${point.icon} text-2xl text-[#C5A880]`}></i>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 font-['Playfair_Display'] leading-snug">
                {point.title}
              </h3>
              <p className="text-white/60 leading-relaxed font-['Montserrat'] text-sm">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Statement */}
        <div className="relative">
          <div className="border border-[#C5A880]/30 rounded-2xl p-8 md:p-10 bg-gradient-to-r from-[#C5A880]/5 via-[#C5A880]/10 to-[#C5A880]/5 text-center">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="w-8 h-px bg-[#C5A880]/50"></div>
              <i className="ri-error-warning-line text-[#C5A880] text-2xl"></i>
              <div className="w-8 h-px bg-[#C5A880]/50"></div>
            </div>
            <p className="text-xl md:text-2xl text-white font-['Playfair_Display'] font-semibold leading-relaxed max-w-3xl mx-auto">
              Хаотичные действия без системы приводят только к{' '}
              <span className="text-[#C5A880]">потере времени и денег</span>
            </p>
            <p className="text-white/50 mt-4 font-['Montserrat'] text-sm">
              Пора выстроить маркетинг как работающий механизм
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
